import React from 'react';


export const AssessDashCircleSVG = 

({ barRadius, barOuterRadius, strokeColorOuter, strokeColorInner, currentScore, comparisonScore ,isCompare, test1, test2, isSwap }) => {

    let score = (currentScore / 36) * 100;
    let scoreComp = (comparisonScore / 36) * 100;
    if (scoreComp < 0) scoreComp = 0;
    let pctCurrent = ((100 - score) / 100) * Math.PI * (barRadius * 2);
    let pctComparison = ((100 - scoreComp) / 100) * Math.PI * (barOuterRadius * 2);
    let scoreValue = comparisonScore.toString().split('.');
    if(isCompare){
        return(
            <svg id="svg" width="auto" height="auto" viewBox="0 0 120 120" version="1.1" xmlns="http://www.w3.org/2000/svg">
            {<circle r={barOuterRadius} cx="60" cy="60" stroke="#F1F1F1" fill="transparent" stroke-dasharray="358" stroke-dashoffset="0"></circle>}
            { <circle r={barOuterRadius} className={strokeColorOuter} cx="60" cy="60" fill="transparent" stroke-dasharray="358" style={{ 'strokeDashoffset': pctComparison }}></circle>}
                <circle className="innerCircle" r={barRadius} cx="60" cy="60" stroke="#DFDFDF" fill="transparent" stroke-dasharray="314" stroke-dashoffset="0"></circle>
                <circle r={barRadius} className={`${strokeColorInner} innerCircle`} cx="60" cy="60" fill="transparent" stroke-dasharray="314" style={{ 'strokeDashoffset': pctCurrent }}></circle>
            {<line x1="115" y1="75" x2="120" y2="102" stroke="#7c7c7c" stroke-width="0.6" />}
                { (<foreignObject width="100" height="157" x="80" y="132" style={{ 'overflow': 'visible' }}>
                    <div xmlns="http://www.w3.org/1999/xhtml" style={{ 'position': 'relative', 'transform': 'rotate(90deg)' }}>
                        <div className=" comparison-donut-legend">
                        <div class="comparison-text">{isSwap ?  test1 : test2 }</div>
                        <ul>
                            <li className='section-score'>
                                {scoreValue[1] ? (<React.Fragment>
                                    <span className="section-score-text">{scoreValue[0]}</span>
                                    <span className="section-score-sub">.{scoreValue[1]}</span>
                                    </React.Fragment>) :
                                    (<span className="section-score-text">{comparisonScore}</span>)
                                }
                            </li>
                        </ul>
                            </div>
                        </div>
                </foreignObject>)
            }
            </svg>
            )
        }else{
            return(
                <svg id="svg" width="auto" height="auto" viewBox="0 0 120 120" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <circle className="innerCircle" r={barRadius} cx="60" cy="60" stroke="#DFDFDF" fill="transparent" stroke-dasharray="314" stroke-dashoffset="0"></circle>
                <circle r={barRadius} className={`${strokeColorInner} innerCircle`} cx="60" cy="60" fill="transparent" stroke-dasharray="314" style={{ 'strokeDashoffset': pctCurrent }}></circle>
            </svg>
         )
        }   

}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessDashCircleSVG.js